import React from 'react';

const MyProfile = () => {
    return (
        <div className="hero min-h-screen bg-base-200">
            <div className="hero-content text-center">
                <div className="max-w-md">
                    <h1 className="text-5xl font-bold">Nosia Akter</h1>
                    <h3><span className='font-bold mt-3'>Email :</span> nurinosia@gmail.com</h3>
                    <p className="py-3">Educational Background Or skills : </p>
                    <p>1.html</p>
                    <p>2.CSS</p>
                    <p>3.JAVAScript</p>
                    <p>4.React</p>
                    <p>5.node.js</p>
                    <p>6.mongoDB</p>
                    <p>7.Express</p>
                    <p>8.Python</p>
                    <p>Note: Since-2021, Studying at National University.</p>
                    <div>
                        <p className="py-3">Project live website link:</p>
                        <li>1. https://epic-hopper-a223cf.netlify.app/</li>
                        <li>2. https://magenta-dusk-6059d3.netlify.app/</li>
                        <li>3. https://628ef0cccc96f10266bbb2d0--nervous-lichterman-029689.netlify.app/</li>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyProfile;